// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OSdY","left":"styles_left__jPabU"};